import { cn } from '@/helpers/classnames';
import { forwardRef } from 'react';

interface SectionProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
  id?: string;
  tutorialId?: string;
}

export const Section = forwardRef<HTMLDivElement, SectionProps>(
  ({ children, className, id, tutorialId, ...rest }, ref) => {
    return (
      <div
        ref={ref}
        id={id}
        className={cn(
          'flex w-full flex-col rounded-md border border-background-300 p-4 sm:p-8',
          className,
        )}
        data-tutorial={tutorialId}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

Section.displayName = 'Section';
